"use strict";

var _ = require("underscore");

/**
 * Liste de phrases ou de fonctions utilisées pour la localisation
 * à utiliser comme ceci : STR.string_id après avoir initialisé la langue dans la fonction init()
 */

var Strings = function () {
};

/**
 * init à appeler une fois tout au début de l'app
 * @param  {String} lang selon ci-dessous, "fr" ou "en" au moins
 */
Strings.prototype.init = function (lang) {
    if (!strings[lang]) {
        lang = "fr"; // langue par défaut
    }
    if (strings[lang]) {
        _.extend(this, strings[lang]);
        strings = []; // plus besoin des strings après la première initialisation, permet de libérer un peu de mémoire
    }
    return lang;
};

function capitalize(s) {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
}

var strings = {
    fr: {
        month_1: "janvier",
        month_2: "février",
        month_3: "mars",
        month_4: "avril",
        month_5: "mai",
        month_6: "juin",
        month_7: "juillet",
        month_8: "août",
        month_9: "septembre",
        month_10: "octobre",
        month_11: "novembre",
        month_12: "décembre",
        document_not_found: "Document non trouvé",
        token_lost: "Cette page va se recharger dans quelques secondes pour réactiver votre autorisation ...",
        token_error: "Document non autorisé",
        date: function (date, removeDay) {
            if (!date) return;
            var datearray = date.split("-"),
                dateFR = "";
            if (datearray.length == 3) {
                if (!removeDay) {
                    dateFR = datearray[2] + " ";
                }
                dateFR += capitalize(new_strings["month_" + parseInt(datearray[1])]) + " " + datearray[0];
            }
            return dateFR;
        },
        tour_skip: "ignorer",
        tour_next: "suivant",
        tour_first_time_title: "Première fois ici?",
        tour_first_time_text: "Prenez en main rapidement la lecture de ce magazine en suivant ce tutoriel.",
        search: "Rechercher",
        print: "Imprimer",
        print_active_page: "Page active",
        print_selected_pages: "Pages sélectionnées",
        print_all_pages: "Toutes les pages",
        annotate: "Annoter",
        print_example: "Par exemple : a-V, 8, 11-13",
        print_error: "Impossible d'imprimer, réessayez plus tard svp",
        print_not_authorized: "L'impression n'est pas autorisée sur ce document pour le moment",
        wrong_syntax_pages: "Veuillez vérifier la syntaxe des pages sélectionnées",
        print_period_w: "semaine",
        print_period_w_plurial: "semaines",
        print_period_h: "heure",
        print_period_h_plurial: "heures",
        print_period_m: "mois",
        print_period_m_plurial: "mois",
        print_period_d: "jour",
        print_period_d_plurial: "jours",
        print_quota_exceeded: "Le quota d'impression est dépassé",
        toc: "Sommaire",
        about: "À propos",
        search_in_progress: "Recherche en cours ...",
        search_previous_page: "P. précédente",
        search_next_page: "P. suivante",
        search_error: "Une erreur est survenue, veuillez réessayer plus tard",
        search_not_found: " non trouvé dans ce document",
        search_found: function (phrase, nb_results) {
            return '«' + phrase + '»' + " trouvé dans " + nb_results + " page" + (nb_results > 1 ? "s" : "");
        },
        voice_not_found: "La langue de ce document n'est pas supportée par ce système",
        copy: "Copier / Coller",
        copy_text: "Copier le texte",
        copy_select_zone: "Sélectionnez une zone de texte à copier dans la page. Vous pourrez alors coller ce texte dans un autre document en cliquant sur le bouton ci-dessous.",
        copy_move_ctrl: "Utilisez la touche CTRL pour vous déplacer.",
        copy_ok: "Le texte est dans le presse-papier",
        copy_nok: "Impossible de copier le texte dans le presse-papier",
        copy_no_text: "Pas de texte trouvé dans cette sélection",
        copy_no_clip: "Votre navigateur ne supporte pas le presse-papier",
        print_pwd: "Votre code pour ce document",
        goto_page: "Aller à la page",
        default_content_auth_message: "<p>Ce contenu n'est pas autorisé dans ce contexte.</p>",
        print_pages_not_authorized: "Certaines pages demandées pour l'impression ne sont pas autorisées dans ce contexte.<br>Veuillez vérifier votre saisie.",
        preferences: "Préférences",
        refresh: "Actualiser cette page",
        pref_display_label: "Qualité d'affichage",
        pref_display_normal: "Toujours standard",
        pref_display_auto: "Auto-adaptée",
        pref_display_high: "Toujours haute",
        pref_note: "Ces paramètres seront pris en compte lors du prochain chargement de cette page.",
        search_placeholder: "Mots recherchés dans ce document",
        switch_page: "Page",
        switch_article: "Article",
        print_copy_code: "Copier le code",
        print_next: "Suivant",
        lang_label_fr: "Français",
        lang_label_it: "Italiano",
        lang_label_en: "English",
        print_quota: "Quota",
        print_quota_consumed: "Consommé",
        print_quota_reset: "Remise à zéro le",
        print_quota_rule: function (nb_pages, period) {
            return nb_pages + " pages par période de " + period;
        },
        print_counter: function (nb_pages) {
            return nb_pages + " page" + (nb_pages > 1 ? "s" : "");
        },
        default_content_web_clipper_message: "<p>Pour enrichir avec des citations vos rapports, présentations, blogs etc… utilisez l'extension Immanens Web Clipper (Chrome seulement).</p><p><em>Attention le contenu partagé peut être soumis à copyright.</em></p>",
        web_clipper: "Web Clipper",
        goto_web_clipper: "Installer l'extension",
        thumbnails: "Mosaïque",
        server_pdf_max_pages: function (max_pages) {
            return "(limité à " + max_pages + ")";
        },
        pref_navigation_label: "Barre de navigation",
        pref_navigation_show: "Afficher",
        pref_navigation_hide: "Ne pas afficher",
        pref_font_size_label: "Taille des textes",
        pref_by_default:"valeur par défaut",
        page_history_stop: "Historique de page vide",
        share: "Copier l'URL",
        share_select: "Vous pouvez désormais copier l'URL du document actif : <br>• Avec le bouton droit de la souris<br>• Avec les raccourcis clavier (Ctrl C)<br>• En cliquant sur le bouton « Copier »",
        share_url: "Copier",
        authorize_popup: "Veuillez autoriser les popups de ce site pour pouvoir imprimer."
    }
};

var new_strings = new Strings();

module.exports = new_strings; // attention on exporte un objet unique


//////////////////
// WEBPACK FOOTER
// ./src/strings.js
// module id = 7
// module chunks = 0